import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/auth';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const isKitchenStaff = user?.isKitchenStaff;
    await logout();
    navigate(isKitchenStaff ? '/kitchen' : '/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-hmh-dark shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <img
              src="https://hmhintuneassets.blob.core.windows.net/iconstorage/HMH-Logo-White.png?sv=2025-07-05&spr=https&st=2025-12-31T19%3A54%3A31Z&se=2054-12-01T19%3A54%3A00Z&sr=b&sp=r&sig=fkkN5B5HXMcBBnQ%2FqWaZukN%2FoE6CaeuguUNs73YKavo%3D"
              alt="HMH Logo"
              className="h-10"
            />
            <span className="text-white font-semibold text-lg">
              {user?.isKitchenStaff ? 'Kitchen Prep' : 'Admin Console'}
            </span>
          </div>
          <div className="flex items-center gap-4">
            {user?.isAdmin && (
              <NavLink
                to="/"
                className="px-4 py-2 bg-white/20 text-white rounded hover:bg-white/30 transition-colors"
              >
                Home
              </NavLink>
            )}
            <span className="text-white">{user?.fullName}</span>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-white/20 text-white rounded hover:bg-white/30 transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>

      {/* Navigation - Only show full nav for admins */}
      {user?.isAdmin && (
        <nav className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex gap-8">
              <NavLink
                to="/admin/orders"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Kitchen Prep
              </NavLink>
              <NavLink
                to="/admin/reports"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Reports
              </NavLink>
              <NavLink
                to="/admin/menu"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Menu Management
              </NavLink>
              <NavLink
                to="/admin/tickets"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Meal Tickets
              </NavLink>
              <NavLink
                to="/admin/birthdays"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Birthdays
              </NavLink>
              <NavLink
                to="/admin/forecasting"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Forecasting
              </NavLink>
              <NavLink
                to="/admin/kitchen-staff"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Kitchen Staff
              </NavLink>
              <NavLink
                to="/admin/printing"
                className={({ isActive }) =>
                  `py-4 px-2 border-b-2 font-medium transition-colors ${
                    isActive ? 'border-hmh-blue text-hmh-blue' : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`
                }
              >
                Printing
              </NavLink>
            </div>
          </div>
        </nav>
      )}

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  );
}
